export const posBar = {
	title: "Devices per Bar",
	columns: {
		bar: "Pub",
		quantity: "Amount",
	},
};
